export default __webpack_public_path__ + "static/media/a3.78a6d9bc.png";